import { h } from 'preact';
import { useSelector } from 'react-redux';

import { routesSelector } from '@core/state/routes/routesSelector';
import { currentPageSelector } from '@core/state/page/pageSelectors';
import translate from '@core/translate';
import withProvider from '@core/state/withProvider';
import Breadcrumbs from '@ui/Breadcrumbs/Breadcrumbs';

function BreadcrumbsManufacturer() {
    const { name, categoryBreadcrumb, displayCategoryBreadcrumb } = useSelector(currentPageSelector);

    return (
        <Breadcrumbs
            homeTitle={translate('breadcrumb.home')}
            enabled={displayCategoryBreadcrumb}
            breadcrumbs={categoryBreadcrumb}
            activeName={name}
        />
    );
}

export default withProvider(BreadcrumbsManufacturer);